"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
var react_1 = __importStar(require("react"));
var Menu_1 = __importDefault(require("semantic-ui-react/dist/commonjs/collections/Menu"));
var classnames_1 = __importDefault(require("classnames"));
var ArrowIcon_1 = __importDefault(require("../../Icons/ArrowIcon"));
require("./MenuItem.css");
var MenuItem = function (props) {
    var activePage = props.activePage, section = props.section, title = props.title, onToggleShowSubMenu = props.onToggleShowSubMenu, isMobile = props.isMobile, mainUrl = props.mainUrl, textColor = props.textColor, backgroundColor = props.backgroundColor;
    var mainRedirect = (0, react_1.useCallback)(function () {
        mainUrl && window.open(mainUrl, '_self');
    }, [mainUrl]);
    return (react_1.default.createElement(Menu_1.default.Item, { active: activePage === section, onClick: function (e) {
            isMobile ? onToggleShowSubMenu(e, true, section) : mainRedirect();
        }, onMouseEnter: function (e) {
            return !isMobile && onToggleShowSubMenu(e, true, section);
        }, onMouseLeave: function (e) {
            return !isMobile && onToggleShowSubMenu(e, false, section);
        }, className: (0, classnames_1.default)('dui-menu-item', section, isMobile && 'mobile', backgroundColor && 'has-background'), style: { color: textColor, backgroundColor: backgroundColor } },
        title,
        isMobile && react_1.default.createElement(ArrowIcon_1.default, null)));
};
exports.MenuItem = MenuItem;
